<style>
  .tscroll {
    width: 100%;
    overflow-x: scroll;
    margin-bottom: 10px;
    border: solid black 1px;
  }

  .tscroll table td:first-child {
    position: sticky;
    left: 0;
    background-color: #ddd;
  }

  .tscroll table th:first-child {
    position: sticky;
    left: 0;
    background-color: #ddd;
  }

  .tscroll td,
  .tscroll th {
    border-bottom: dashed #888 1px;
    width: auto;
  }

  .tscroll table td:nth-child(2) {
    position: sticky;
    left: 4rem;
    background-color: #ddd;
  }

  .tscroll table th:nth-child(2) {
    position: sticky;
    left: 4rem;
    background-color: #ddd;
  }

  .col2 {
    z-index: 2;
  }

  .deployment-form-control {
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.5;

    display: block;

    width: auto;
    height: calc(1.5em + 1.25rem + 2px);
    padding: 0.625rem 0.75rem;

    transition: all 0.15s cubic-bezier(0.68, -0.55, 0.265, 1.55);

    color: #555;
    border: 1px solid #cccccc;
    border-radius: 0.25rem;
    background-color: #fff;
    background-clip: padding-box;
    box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  }
</style>

<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 bg-head-light">
          <div class="col-lg-6 col-5">
            <h1 style="justify-content: center;" class="h3 mb-0">Card Transaction Entry</h1>
          </div>
          <div class="col-lg-6 col-7">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4 float-right">
              <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                <li class="breadcrumb-item">
                  <i class="fas fa-home"></i>
                </li>
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">Card Transaction Entry </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div class="container">
      <label *ngFor="let radiobutton of radioItems" class="pr-3 py-3 cursor-pointer">
        <input type="radio" name="options m-0" (click)="onRadioButtonClicked(radiobutton)"
          [checked]="radiobutton === 'Configure Excel Header'" style="margin-right: 0px;">
        {{radiobutton}}
      </label>

      <div class="requested-form p-0" *ngIf="!isShowImportFromExcel">
        <div *ngIf="!isHeaderExists">
          <form [formGroup]="TransactionEntryForm" (ngSubmit)="onAddRequest()">
            <div class="row">
              <div class="col-md-6">
                <div class="card gutter-b">
                  <div class="card-header">
                    <div style="clear: both">
                      <h3 style="float: left">Field</h3>
                      <h3 style="float: right">Header Name In Excel</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4" for="SettlementDate">Settlement Date <sup
                        class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"
                       formControlName="SettlementDate"
                        class="form-control" id="SettlementDate"
                        [ngClass]="{ 'is-invalid': submitted && f.SettlementDate.errors }">
                      <div *ngIf="submitted && f.SettlementDate.errors" class="invalid-feedback">
                        <div *ngIf="f.SettlementDate.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="TrxDate">Transaction Date <sup
                        class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="TrxDate"
                        class="form-control" id="TrxDate"
                        [ngClass]="{ 'is-invalid': submitted && f.TrxDate.errors }">
                      <div *ngIf="submitted && f.TrxDate.errors" class="invalid-feedback">
                        <div *ngIf="f.TrxDate.errors.required">  Required</div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group row">
                    <label class="col-md-4" for="MerchantAccount">Merchant Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="MerchantAccount"
                        class="form-control" id="MerchantAccount"
                        [ngClass]="{ 'is-invalid': submitted && f.MerchantAccount.errors }">
                      <div *ngIf="submitted && f.MerchantAccount.errors" class="invalid-feedback">
                        <div *ngIf="f.MerchantAccount.errors.required">Required</div>
                      </div>
                    </div>
                  </div> -->

                  <div class="form-group row">
                    <label class="col-md-4" for="MerchantNumber">Merchant Number<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="MerchantNumber"
                        class="form-control" id="MerchantNumber"
                        [ngClass]="{ 'is-invalid': submitted && f.MerchantNumber.errors }">
                      <div *ngIf="submitted && f.MerchantNumber.errors" class="invalid-feedback">
                        <div *ngIf="f.MerchantNumber.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="TerminalNumber">Terminal Number<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="TerminalNumber"
                        class="form-control" id="IdTerminal"
                        [ngClass]="{ 'is-invalid': submitted && f.TerminalNumber.errors }">
                      <div *ngIf="submitted && f.TerminalNumber.errors" class="invalid-feedback">
                        <div *ngIf="f.TerminalNumber.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="CardMask">Card Mask<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="CardMask"
                        class="form-control" id="CardMask" [ngClass]="{ 'is-invalid': submitted && f.CardMask.errors }">
                      <div *ngIf="submitted && f.CardMask.errors" class="invalid-feedback">
                        <div *ngIf="f.CardMask.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="RRN">RRN <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="RRN"
                        class="form-control" id="RRN" [ngClass]="{ 'is-invalid': submitted && f.RRN.errors }">
                      <div *ngIf="submitted && f.RRN.errors" class="invalid-feedback">
                        <div *ngIf="f.RRN.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="CardType">Card Type <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="CardType"
                        class="form-control" id="CardType" [ngClass]="{ 'is-invalid': submitted && f.CardType.errors }">
                      <div *ngIf="submitted && f.CardType.errors" class="invalid-feedback">
                        <div *ngIf="f.CardType.errors.required">Required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card gutter-b">
                  <div class="card-header">
                    <div style="clear: both">
                      <h3 style="float: left">Field</h3>
                      <h3 style="float: right">Header Name In Excel</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4" for="Network">Network<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="Network"
                        class="form-control" id="Network" [ngClass]="{ 'is-invalid': submitted && f.Network.errors }">
                      <div *ngIf="submitted && f.Network.errors" class="invalid-feedback">
                        <div *ngIf="f.Network.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="MerchantName">Merchant Name <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="MerchantName"
                        class="form-control" id="MerchantName"
                        [ngClass]="{ 'is-invalid': submitted && f.MerchantName.errors }">
                      <div *ngIf="submitted && f.MerchantName.errors" class="invalid-feedback">
                        <div *ngIf="f.MerchantName.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Merchant Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="MerchantAccount" id="MerchantAccount" name="MerchantAccount"
                        [ngClass]="{ 'is-invalid': submitted && f.MerchantAccount.errors }" />
                      <div *ngIf="submitted && f.MerchantAccount.errors" class="invalid-feedback">
                        <div *ngIf="f.MerchantAccount.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Transaction Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="TrxAmount" id="TrxAmount" name="TrxAmount"
                        [ngClass]="{ 'is-invalid': submitted && f.TrxAmount.errors }" />
                      <div *ngIf="submitted && f.TrxAmount.errors" class="invalid-feedback">
                        <div *ngIf="f.TrxAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">MSC Rate <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="MSCRate" id="MSCRate" name="MSCRate"
                        [ngClass]="{ 'is-invalid': submitted && f.MSCRate.errors }" />
                      <div *ngIf="submitted && f.MSCRate.errors" class="invalid-feedback">
                        <div *ngIf="f.MSCRate.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">MSC Amount <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="MSCAmount" id="MSCAmount" name="MSCAmount"
                        [ngClass]="{ 'is-invalid': submitted && f.MSCAmount.errors }" />
                      <div *ngIf="submitted && f.MSCAmount.errors" class="invalid-feedback">
                        <div *ngIf="f.MSCAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Settlement Amount <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="SettlementAmount" id="SettlementAmount" name="SettlementAmount"
                        [ngClass]="{ 'is-invalid': submitted && f.SettlementAmount.errors }" />
                      <div *ngIf="submitted && f.SettlementAmount.errors" class="invalid-feedback">
                        <div *ngIf="f.SettlementAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *has-permission="Permission.CardTransactionHeader" class="d-flex justify-content-evenly">
              <button *ngIf="!isUpdate" [disabled]="loading" class="btn btn-neutral"> <span *ngIf="loading"
                  class="spinner-border spinner-border-sm mr-1"></span> Add</button>
              <button *ngIf="isUpdate" color="primary" (click)="UpdateRequest()" class="btn btn-neutral"> ADD
              </button>
              <button *ngIf="isUpdate" color="warn" (click)="Cancel()" class="btn btn-outline"> Cancel </button>
            </div>
          </form>
        </div>
        <div *ngIf="isHeaderExists" (ngSubmit)="onUpdate()">
          <form [formGroup]="TransactionUpdateForm" >
            <div class="row">
              <div class="col-md-6">
                <div class="card gutter-b">
                  <div class="card-header">
                    <div style="clear: both">
                      <h3 style="float: left">Field</h3>
                      <h3 style="float: right">Header Name In Excel</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4" for="settlementDate">Settlement Date <sup
                        class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"
                       formControlName="settlementDate"
                        class="form-control" id="settlementDate"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.settlementDate.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.settlementDate.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.settlementDate.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="trxDate">Transaction Date <sup
                        class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="trxDate"
                        class="form-control" id="trxDate"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.trxDate.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.trxDate.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.trxDate.errors.required">  Required</div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="form-group row">
                    <label class="col-md-4" for="merchantAccount">Merchant Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="merchantAccount"
                        class="form-control" id="merchantAccount"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.merchantAccount.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.merchantAccount.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.merchantAccount.errors.required">Required</div>
                      </div>
                    </div>
                  </div> -->

                  <div class="form-group row">
                    <label class="col-md-4" for="merchantNumber">Merchant Number<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="merchantNumber"
                        class="form-control" id="merchantNumber"
                        [ngClass]="{ 'is-invalid': submitted && f.merchantNumber.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.merchantNumber.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.merchantNumber.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="terminalNumber">Terminal Number<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="terminalNumber"
                        class="form-control" id="terminalNumber"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.terminalNumber.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.terminalNumber.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.terminalNumber.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="cardMask">Card Mask<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="cardMask"
                        class="form-control" id="cardMask" [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.cardMask.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.cardMask.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.cardMask.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="rrn">RRN <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="rrn"
                        class="form-control" id="rRN" [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.rrn.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.rrn.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.rrn.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="cardType">Card Type <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="cardType"
                        class="form-control" id="cardType" [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.cardType.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.cardType.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.cardType.errors.required">Required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card gutter-b">
                  <div class="card-header">
                    <div style="clear: both">
                      <h3 style="float: left">Field</h3>
                      <h3 style="float: right">Header Name In Excel</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4" for="network">Network<sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="network"
                        class="form-control" id="network" [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.network.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.network.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.network.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4" for="merchantName">Merchant Name <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  formControlName="merchantName"
                        class="form-control" id="merchantName"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.merchantName.errors }">
                      <div *ngIf="submitted && TransactionUpdateFormControls.merchantName.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.merchantName.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Merchant Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="merchantAccount" id="merchantAccount" name="merchantAccount"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.merchantAccount.errors }" />
                      <div *ngIf="submitted && TransactionUpdateFormControls.merchantAccount.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.merchantAccount.errors.required">Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Transaction Account <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="trxAmount" id="trxAmount" name="trxAmount"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.trxAmount.errors }" />
                      <div *ngIf="submitted && TransactionUpdateFormControls.trxAmount.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.trxAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">MSC Rate <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="mscRate" id="mscRate" name="mscRate"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.mscRate.errors }" />
                      <div *ngIf="submitted && TransactionUpdateFormControls.mscRate.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.mscRate.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">MSC Amount <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="mscAmount" id="mscAmount" name="mscAmount"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.mscAmount.errors }" />
                      <div *ngIf="submitted && TransactionUpdateFormControls.mscAmount.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.mscAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-4">Settlement Amount <sup class="required-sign">*</sup></label>
                    <div class="col-md-8">
                      <input type="text"  class="form-control"
                        formControlName="settlementAmount" id="settlementAmount" name="settlementAmount"
                        [ngClass]="{ 'is-invalid': submitted && TransactionUpdateFormControls.settlementAmount.errors }" />
                      <div *ngIf="submitted && TransactionUpdateFormControls.settlementAmount.errors" class="invalid-feedback">
                        <div *ngIf="TransactionUpdateFormControls.settlementAmount.errors.required"> Required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *has-permission="Permission.CardTransactionHeaderUpdate" class="d-flex justify-content-evenly">
              <button *ngIf="isHeaderExists" color="primary" (click)="onUpdate()" class="btn btn-neutral"> Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>


  <div *ngIf="isShowImportFromExcel">
    <div class="container">
      <span style="color: darkcyan;">While uploading data from Excel ,please make sure upload data format matches the
        format that can be downloaded from below.
      </span>
      <div class="py-3 bg-white my-3 mt-1" style="width: 1100px;">
        <button class="btn btn-primary" (click)="export()">Click to download Upload Format</button>
        &nbsp;&nbsp;
        <div class="container1" appDnd (fileDropped)="onFileDropped($event)">
          <input type="file" #fileDropRef id="fileDropRef1" (change)="addFile($event)" onclick="this.value=null;" class="input1"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
          <img alt="uploading..." class="upload" src="./assets/img/upload_excel.png" width="60" height="60">
          <h4>Drag and drop file here</h4>
          <h4>or</h4>
          <label class="label1" for="fileDropRef">Browse for file</label>
        </div>
        <div class="files-list" *ngIf="fileLength > 0">
          <div class="single-file">
            <div class="file-icon" style="width: 50px">
            <img alt="file Icon.." src="./assets/img/excel_file_icon.png" width="50" height="50" >
            </div>
            <div class="info">
              <h4 class="name">
                {{ files[0]?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(files[0]?.size) }}
              </p>
              <app-progress [progress]="files.progress"></app-progress>
            </div>
            <div class="delete" (click)="deleteFile()">
            <img alt="delete-icon..." src="./assets/img/delete_icon.png" width="50" height="50">
            </div>
          </div>
       </div>

      </div>
    </div>

    <div class="tscroll sheet-list-edit pb-4 border-0 mx-3" *ngIf="isShowTable">
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Action</th>
              <th class="col2">S.N.</th>
              <th>SETTLEMENT DATE</th>
              <th>TRANSACTION DATE</th>
              <th>MERCHANT NUMBER</th>
              <th>TERMINAL NUMBER</th>
              <th>CARD MASK</th>
              <th>RRN</th>
              <th>CARD TYPE</th>
              <th>NETWORK</th>
              <th>MERCHANT NAME</th>
              <th>MERCHANT ACCOUNT</th>
              <th>TRANSACTION ACCOUNT</th>
              <th>MSC RATE</th>
              <th>MSC AMOUNT</th>
              <th>SETTLEMENT AMOUNT</th>
            </tr>
          </thead>
          <tbody formArrayName="transactionEntryArray">
            <ng-container *ngFor="let transactionEntry of transactionEntryArray.controls; let i = index">
              <tr [formGroupName]="i">
                <td style="z-index: 1;"><button class="btn-danger" type="button" (click)="deleteRequest(i)"><i
                      class="fas fa-trash" aria-hidden="true"></i></button>
                </td>
                <td class="col2"><span *ngIf="transactionEntry.invalid" class="alert-danger"><i
                      class="fa fa-exclamation-triangle" aria-hidden="true"></i></span>{{ i+1 }}
                </td>
                <td>
                  <input type="text" formControlName="SettlementDate" id="SettlementDate{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('SettlementDate').invalid && (transactionEntry.get('SettlementDate').dirty || transactionEntry.get('SettlementDate').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('SettlementDate').errors.required">
                      Settlement Date is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="TrxDate" id="TrxDate{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('TrxDate').invalid && (transactionEntry.get('TrxDate').dirty || transactionEntry.get('TrxDate').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('TrxDate').errors.required">
                      Transaction Date is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="MerchantNumber" id="MerchantNumber{{i}}"
                    class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('MerchantNumber').invalid && (transactionEntry.get('MerchantNumber').dirty || transactionEntry.get('MerchantNumber').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('MerchantNumber').errors.required">
                      Merchant Number is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="TerminalNumber" id="TerminalNumber{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('TerminalNumber').invalid && (transactionEntry.get('TerminalNumber').dirty || transactionEntry.get('TerminalNumber').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('TerminalNumber').errors.required">
                      Terminal Number is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="CardMask" id="CardMask{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('CardMask').invalid && (transactionEntry.get('CardMask').dirty || transactionEntry.get('CardMask').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('CardMask').errors.required">
                      Card Mask is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="RRN" id="RRN{{i}}"
                    class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('RRN').invalid && (transactionEntry.get('RRN').dirty || transactionEntry.get('RRN').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('RRN').errors.required">
                      RRN is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="CardType" id="CardType{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('CardType').invalid && (transactionEntry.get('CardType').dirty || transactionEntry.get('CardType').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('CardType').errors.required">
                      Card Type is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="Network" id="Network{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('Network').invalid && (transactionEntry.get('Network').dirty || transactionEntry.get('Network').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('Network').errors.required">
                      Network is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="MerchantName" id="MerchantName{{i}}"
                    class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('MerchantName').invalid && (transactionEntry.get('MerchantName').dirty || transactionEntry.get('MerchantName').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('MerchantName').errors.required"> Merchant Name is required. </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="MerchantAccount" id="MerchantAccount{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('MerchantAccount').invalid && (transactionEntry.get('MerchantAccount').dirty || transactionEntry.get('MerchantAccount').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('MerchantAccount').errors.required">
                      Merchant Account is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="TrxAmount" id="TrxAmount{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('TrxAmount').invalid && (transactionEntry.get('TrxAmount').dirty || transactionEntry.get('TrxAmount').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('TrxAmount').errors.required">
                      Transaction Amount is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="MSCRate" id="MSCRate{{i}}"
                    class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('MSCRate').invalid && (transactionEntry.get('MSCRate').dirty || transactionEntry.get('MSCRate').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('MSCRate').errors.required">
                      MSC Rate is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="MSCAmount" id="MSCAmount{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('MSCAmount').invalid && (transactionEntry.get('MSCAmount').dirty || transactionEntry.get('MSCAmount').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('MSCAmount').errors.required">
                      MSC Amount is required.
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" formControlName="SettlementAmount" id="SettlementAmount{{i}}" class="deployment-form-control">
                  <div
                    *ngIf="transactionEntry.get('SettlementAmount').invalid && (transactionEntry.get('SettlementAmount').dirty || transactionEntry.get('SettlementAmount').pristine)"
                    class=" alert-danger">
                    <div *ngIf="transactionEntry.get('SettlementAmount').errors.required">
                      Settlement Amount is required.
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
          <div *has-permission="Permission.CardTransactionHeader" class="py-3">
            <button class="btn btn-info" (click)='addRequest()' style="margin-left: 10px; position: absolute;"><i
                class="fa fa-plus" aria-hidden="true">Add More</i></button>
            <button type="submit" class="btn btn-primary"
              style="margin-left: 10px; right: 20px; position: absolute;">Submit</button><br>
          </div>
        </table>
      </form>
    </div>
  </div>
</article>
